import React, {forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState} from "react";
import {cmpClassName, execFn} from "../../../common/generic-react.functions.js";
import {TooltipContainer, TooltipTextContainer} from "./tooltip.styles.js";
function MainTooltip({
  children,
  color = "white",
  bgColor = "black",
  text,
  position = "top",
  show,
  width = 120,
  onMouseEnter,
  onMouseLeave,
  onClick
}, ref) {
  const [showTooltip, setShowTooltip] = useState(show);
  const baseRef = useRef(null);
  useEffect(() => {
    setShowTooltip(show);
  }, [show]);
  const showAction = useCallback(() => setShowTooltip(true), []);
  const hideAction = useCallback(() => setShowTooltip(false), []);
  const toggleAction = useCallback(() => setShowTooltip((state) => !state), []);
  const mouseEnter = useCallback(() => {
    showAction();
    execFn(onMouseEnter);
  }, [onMouseEnter, showAction]);
  const mouseLeave = useCallback(() => {
    hideAction();
    execFn(onMouseLeave);
  }, [hideAction, onMouseLeave]);
  const click = useCallback(() => {
    toggleAction();
    execFn(onClick);
  }, [onClick, toggleAction]);
  useImperativeHandle(ref, () => {
    return {
      el: baseRef.current,
      toggle: toggleAction,
      show: showAction,
      hide: hideAction
    };
  }, [hideAction, showAction, toggleAction]);
  return /* @__PURE__ */ React.createElement(TooltipContainer, {
    className: cmpClassName("tooltip"),
    ref: baseRef,
    onMouseEnter: mouseEnter,
    onMouseLeave: mouseLeave,
    onClick: click
  }, showTooltip && /* @__PURE__ */ React.createElement(TooltipTextContainer, {
    role: "tooltip",
    color,
    bgColor,
    position,
    width
  }, text), children);
}
const Tooltip = /* @__PURE__ */ React.memo(/* @__PURE__ */ forwardRef(MainTooltip));
Tooltip.displayName = "Tooltip";
export default Tooltip;
